import toast from 'react-hot-toast';
import { AttachmentTypeIcon } from './FileTypeIcon';

export function AttachmentLinkCell({ url }) {
  const handleCopy = (e) => {
    e.stopPropagation();
    if (!url) return;
    navigator.clipboard.writeText(url);
    toast.success('Link copied successfully.');
  };

  return (
    <div
      onClick={handleCopy}
      className="cursor-pointer hover:opacity-80 transition-opacity w-max"
      title="Click to copy link"
    >
      <AttachmentTypeIcon mimeType="link" />
    </div>
  );
}
